import { SVGInterface } from "../../interface";

const FileUpload = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.5 16.42L16 15.01L12.01 11L8 15.01Z"
      fill={color || "#0E171F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 20.0009C4 21.1054 4.89543 22.0009 6 22.0009H18C19.1046 22.0009 20 21.1054 20 20.0009V9.00087C19.9964 8.99373 19.9921 8.98702 19.987 8.98087V8.97487C19.9832 8.96561 19.9809 8.95583 19.98 8.94587C19.9754 8.85805 19.9589 8.77126 19.931 8.68787V8.65987C19.924 8.63687 19.917 8.61587 19.908 8.59387C19.8596 8.48493 19.7918 8.38566 19.708 8.30087L13.708 2.30087C13.6232 2.21706 13.5239 2.1493 13.415 2.10087C13.3988 2.08518 13.3814 2.0708 13.363 2.05787H13.321C13.2373 2.02967 13.1502 2.01252 13.062 2.00687C13.0522 2.00584 13.0424 2.00383 13.033 2.00087H13.027C13.018 1.99971 13.009 1.99971 13 2.00087H6C4.89543 2.00087 4 2.8963 4 4.00087V20.0009ZM6 20.0009V4.00087H12V9.00087C12 9.55316 12.4477 10.0009 13 10.0009H18V20.0009H6ZM14 8.00087V5.41487L16.586 8.00087H14Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default FileUpload;
